import HttpClient from '../../../services/http-client';
import { IBannerAddEditRequest } from '../../../../model/apm/banner/request/banner-add-edit-request';
import { IBannerResponse } from '../../../../model/apm/banner/response/banner-response';

const defaultPath = 'Banner';

// Lista completa na ordem de exibição do portal
const list = async (): Promise<IBannerResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`
    }).then((response) => response.data || []);
};

const getById = async (id: number): Promise<IBannerResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IBannerAddEditRequest): Promise<IBannerResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    }).then((response) => response.data);
};

const edit = async (id: number, params: IBannerAddEditRequest): Promise<IBannerResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const changePublication = async (id: number, isPublished: boolean): Promise<IBannerResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}/Publication`,
        data: { isPublished }
    }).then((response) => response.data);
};

const reorder = async (ids: number[]): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/Order`,
        data: { ids }
    });
};

const BannerAppService = { list, getById, add, edit, remove, changePublication, reorder };
export default BannerAppService;
